/* SHOP PAGE — banner video (plays only while on screen) and ADD TO CART on the posters. */
(function () {
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var video = document.querySelector('[data-nhp-shop-video]');
  var pause = document.querySelector('[data-nhp-shop-pause]');

  if (video && pause) {
    var wanted = !reduce;            // what the viewer asked for
    var onScreen = false;

    function apply() {
      if (wanted && onScreen) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
      else video.pause();
      pause.setAttribute('aria-pressed', wanted ? 'false' : 'true');
      pause.querySelector('.nhp-sr').textContent = wanted ? 'Pause the video' : 'Play the video';
    }

    pause.addEventListener('click', function () { wanted = !wanted; apply(); });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        onScreen = entries[0].isIntersecting;
        apply();
      }, { threshold: 0.2 }).observe(video);
    } else {
      onScreen = true;
      apply();
    }
    // never burn battery on a hidden tab
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) video.pause(); else apply();
    });
    if (reduce) video.removeAttribute('loop');
  }

  /* the posters' ADD TO CART (the homepage's handler lives in nhp-now-showing.js, which this page
     does not load) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.nhp-shop [data-nhp-add]');
    if (!btn || !window.NNCart) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'ADDING…';
    window.NNCart.addAndOpen(btn.getAttribute('data-nhp-add'), 1)
      .then(function () { btn.textContent = label; })
      .catch(function () { btn.textContent = 'TRY AGAIN'; })
      .then(function () { btn.disabled = false; });
  });
})();
